import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import {cloneDeep, isEmpty, pick} from "lodash-es";
import store from 'appRoot/Store';
import {settingActions} from 'app/reducers/settings/slice';
import SimpleDialogActions from 'app/actions/simpleDialog.actions';

const NS = 'SettingsBookingsCtrl';

export default function SettingsBookingsCtrl(
  $mdToast, $mdDialog, $scope
) {
  "ngInject";

  const vm = this;

  //-- define public properties
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.ERROR = 3;
  vm.state = vm.LOADING;
  //-- define public methods
  vm.save = save;
  vm.updateEventBlockouts = updateEventBlockouts;

  vm.handleSelectMandatoryEditing = handleSelectMandatoryEditing;
  vm.rememberedStaffNew = null
  vm.rememberedStaffEdit = null
  vm.checkAll = checkAll;
  vm.isExistingVenue = null
  vm.showNewStaffInitialChanges = window.config?.enableAdvancedStaffSettings;
  vm.handleSelectMandatoryCreating = handleSelectMandatoryCreating;
  vm.changeEditAll = changeEditAll;
  vm.changeMandatoryWhenCreating = changeMandatoryWhenCreating;
  const ACTIVE = 'active';
  const INACTIVE = 'inactive';
  vm.creatingMandatoryRequired = false;
  vm.editingMandatoryRequired = false;

  let originalShowNewSideBar;

  init();

  function init() {
    GeneralSettingsService.get().then(settings => {
      console.log('vm.showNewStaffInitialChanges', vm.showNewStaffInitialChanges)
      originalShowNewSideBar = settings.showNewSideBar;
      const _settings = cloneDeep(settings);
      vm.isExistingVenue = vm.showNewStaffInitialChanges ? (Object.hasOwn(_settings, 'staffEditEnabled') || Object.hasOwn(_settings, 'staffEnabled')) : false
      _settings.highlightConflictsMins = _settings.highlightConflictsMins || 15;
      vm.state = vm.ENTER;
      vm.settings = _settings;
      if (vm.isExistingVenue) {
        if (!Object.hasOwn(_settings, 'staffNew') && _settings.staffRequired) {
          vm.settings.staffNew = {
            creatingBooking: true,
            changingDate: true
          }
        }
      }
      if (vm.isExistingVenue) {
        if (!Object.hasOwn(_settings, 'staffEdit') && _settings.staffEditRequired) {
          vm.settings.staffEdit = {
            staffEditAll: true,
            staffEditQuickEdit: true,
            staffEditPaxEdit: true,
            staffEditTableEdit: true,
            staffEditTimeEdit: true,
            staffEditPaymentBOEdit: true,
            staffEditNotesEdit: true,
            staffEditStatusEdit: true
          }
        }
      }
      const account = AdminService.getAccount();
      // show recurring booking tickbox for NBIAdmin and Staff members
      vm.isAdminOrStaff = account.roles?.some(role => role.name === 'BookItAdmin' || role.name === 'BookItStaff');
      setPendoTrackingValues();
    });
  }

  function turnExistingVenueOff() {
    vm.isExistingVenue = false
  }

  function save(isValid) {
    let isStaffNameFieldValid = true;
    if(vm.showNewStaffInitialChanges) {
      const formElement = document.getElementById('booking-settings');
      const toTop = () =>
        formElement.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      const atLeastOptionWhenCreating =
        !isEmpty(vm.settings.staffNew) && Object.values(vm.settings.staffNew).some((i) => i);
      if (vm.settings.staffRequired && !atLeastOptionWhenCreating) {
        vm.creatingMandatoryRequired = true;
      }

      const atLeastOptionWhenEditing =
        !isEmpty(vm.settings.staffEdit) && Object.values(vm.settings.staffEdit).some((i) => i);
      if (vm.settings.staffEditRequired && !atLeastOptionWhenEditing) {
        vm.editingMandatoryRequired = true;
      }

      isStaffNameFieldValid = !vm.editingMandatoryRequired && !vm.creatingMandatoryRequired;

      if (!isStaffNameFieldValid) {
        toTop();
      }
    }


    if (isValid && isStaffNameFieldValid) {
      vm.state = vm.LOADING;
      GeneralSettingsService.save(vm.settings).then(settings => {
        vm.rememberedStaffNew = null
        vm.rememberedStaffEdit = null
        store.dispatch(settingActions.setGeneralSettings(settings))
        vm.settings = cloneDeep(settings);
        vm.state = vm.ENTER;
        setPendoTrackingValues();
        $mdToast.show(
          $mdToast.simple()
            .content('General Settings Saved')
            .position('bottom right')
            .theme('saved')
            .hideDelay(3000)
        );

        // forces reload for BookingCreator or BookingCardList changes due to complex initialisation (cheap solution)
        if (originalShowNewSideBar !== settings.showNewSideBar) {
          SimpleDialogActions.showDialog({
            description: 'Please reload the app for changes to take effect',
            title: 'Reload',
            confirmText: 'Reload',
            handleConfirm: () => {
              window.location.reload();
            },
            handleReject: () => {
              window.location.reload();
            }
          });
        }

      }).catch(function (err) {
        console.error('err', err);
      });
    } else {
      vm.displayErrors = true;
    }
  }

  function updateEventBlockouts(eventBlockoutSettings) {
    vm.settings.staffRequiredCreateBlockout = eventBlockoutSettings.staffRequiredCreateBlockout;
    vm.settings.staffRequiredCreateEvent = eventBlockoutSettings.staffRequiredCreateEvent;
    vm.settings.staffRequiredEditBlockout = eventBlockoutSettings.staffRequiredEditBlockout;
    vm.settings.staffRequiredEditEvent = eventBlockoutSettings.staffRequiredEditEvent;
  }

  function setPendoTrackingValues() {
    vm.enableRecurringBookingsValue = vm.settings.enableRecurringBookings ? ACTIVE : INACTIVE;
  }

  function handleSelectMandatoryEditing(checkedVal) {
    turnExistingVenueOff()
    if (checkedVal) {
      if (vm.rememberedStaffEdit) {
        vm.settings.staffEdit = vm.rememberedStaffEdit
      }
    } else {
      vm.editingMandatoryRequired = false
      vm.rememberedStaffEdit = cloneDeep(vm.settings.staffEdit)
      vm.settings.staffEdit = {
        staffEditAll: checkedVal,
        staffEditQuickEdit: checkedVal,
        staffEditPaxEdit: checkedVal,
        staffEditTableEdit: checkedVal,
        staffEditTimeEdit: checkedVal,
        staffEditPaymentBOEdit: checkedVal,
        staffEditNotesEdit: checkedVal,
        staffEditStatusEdit: checkedVal
      };
    }
  }

  function handleSelectMandatoryCreating(checkedVal) {
    turnExistingVenueOff()
    if (checkedVal) {
      if (vm.rememberedStaffNew) {
        vm.settings.staffNew = vm.rememberedStaffNew
      }
    } else {
      vm.creatingMandatoryRequired = false
      vm.rememberedStaffNew = cloneDeep(vm.settings.staffNew)
      vm.settings.staffNew = {
        creatingBooking: checkedVal,
        changingDate: checkedVal,
        creatingWalkin: checkedVal,
      };
    }

  }

  function checkAll(checkedVal) {
    vm.settings.staffEdit = {
      staffEditAll: checkedVal,
      staffEditQuickEdit: checkedVal,
      staffEditPaxEdit: checkedVal,
      staffEditTableEdit: checkedVal,
      staffEditTimeEdit: checkedVal,
      staffEditPaymentBOEdit: checkedVal,
      staffEditNotesEdit: checkedVal,
      staffEditStatusEdit: checkedVal
    };

    // Reset validation for "mandatory edit booking" when select "All eidts"
    if (checkedVal) {
      vm.editingMandatoryRequired = false
    }
  }

  function changeMandatoryWhenCreating() {
    const hasSelected = Object.values(vm.settings.staffNew).some(i => i)
    if (hasSelected) {
      if(vm.creatingMandatoryRequired) {
        vm.creatingMandatoryRequired = false
      }
      vm.settings.staffRequired = true
    }
  }

  // if all the options for edit are true staffEditAll is true automatically - even if one is false vm.settings.staffEdit.staffEditAll will be unchecked
  function changeEditAll(val) {
    turnExistingVenueOff()

    // Validation
    const hasSelected = Object.values(vm.settings.staffEdit).some(i => i)
    if (hasSelected) {
      vm.editingMandatoryRequired = false
      vm.settings.staffEditRequired = true
    }


    // staffEditAll input checking
    if (vm.settings.staffEdit) {
      const {
        staffEditAll,
        ...allSubWithoutStaffEditAll
      } = vm.settings.staffEdit
      if (Object.values(allSubWithoutStaffEditAll).every(i => i)) {
        vm.settings.staffEdit.staffEditAll = true
      }

      if (Object.values(allSubWithoutStaffEditAll).some(i => !i)) {
        vm.settings.staffEdit.staffEditAll = false
      }
    }
  }
}
